import React from 'react';
import PropType from 'prop-types';
import classnames from 'classnames';

class BbButton extends React.Component {
    static propTypes = {
        disabled: PropType.bool,
        small: PropType.bool,
        gradient: PropType.number,
        onClick: PropType.func
    };

    static defaultProps = {
        disabled: false,
        small: false,
        gradient: 0,
        onClick: () => null
    };

    render() {
        return (
            <button
                className={classnames("bb-button", {
                    "is-square": localStorage.locales_button_style === "square",
                    "small": this.props.small,
                    "gradient-1": this.props.gradient === 1,
                    "gradient-2": this.props.gradient === 2,
                    "gradient-3": this.props.gradient === 3,
                })}
                type="button"
                onClick={this.props.onClick}
                disabled={this.props.disabled}
            >
                {this.props.children}
            </button>
        );
    }
}

export default BbButton